// client/src/components/School_Admin/Dashboard/StaffDistributionChart.js
//
// A PIE, NOT A BAR — see the note at the top of DistributionPie.
//
// This one was already multicoloured, and that was the tell: colouring bars by
// category is a pie's encoding drawn on a bar's axis. "Staff by role" is a
// part-to-whole question, and it is now asked as one.

import React from 'react';
import DistributionPie from './DistributionPie';

const StaffDistributionChart = ({ data }) => (
  <DistributionPie
    items={(Array.isArray(data) ? data : []).map((item) => ({
      label: item.role || item.name || 'Staff',
      value: item.count,
    }))}
    unitLabel="staff"
    emptyText="No staff distribution data available"
    // Shorter than its two neighbours because it sits in a column of its own
    // beside them rather than in the shared row.
    height={250}
  />
);

export default StaffDistributionChart;
